// src/services/api.js

// Set API_BASE depending on environment
const API_BASE = process.env.REACT_APP_API_BASE || window.location.origin;

async function safeJsonFetch(url, options = {}) {
  try {
    const res = await fetch(url, options);

    const text = await res.text();

    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (err) {
      // If response is not JSON, include raw text in error
      throw new Error(`Failed to parse JSON response from ${url}: ${text}`);
    }

    if (!res.ok) {
      throw new Error(`HTTP ${res.status} error: ${data.message || text}`);
    }

    return data;
  } catch (err) {
    console.error(`Fetch error for ${url}:`, err);
    throw err;
  }
}

export async function getDiscoAlerts(query = {}) {
  const qs = new URLSearchParams(query).toString();
  const url = `${API_BASE}/api/nepa-alerts/disco-alerts${qs ? `?${qs}` : ''}`;
  return safeJsonFetch(url);
}

export async function postReport(payload = {}) {
  const url = `${API_BASE}/api/nepa-alerts/report-outage`;
  return safeJsonFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
